import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const imageTransform = {
  fetchImageTransform: lazyModuleMethod(
    () => import('./fetchImageTransform'),
    'default'
  ),
}
